<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="24" :xs="24">
        <!-- 搜索表单 -->
        <el-form :model="queryParams" ref="queryForm" size="small" v-show="showSearch" label-width="100px">
          <el-row :gutter="24" type="flex" justify="right">
            <el-col :span="8">
              <el-form-item label="检测日期" prop="testEmployeeDate">
                <el-date-picker v-model="queryParams.testEmployeeDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                                style="width: 100%;" @change="handleSearch" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="客户名称" prop="compNames">
                <el-input v-model="queryParams.compNames" placeholder="请输入客户名称" clearable @keyup.enter.native="handleSearch" />
                <CustomerDetails v-model="queryParams.compNames" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 功能按钮区域 -->
          <div style="text-align: center;margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleSearch="handleSearch" @handleReset="handleReset" @exportToExcel="exportToExcel" />
          </div>

          <!-- 数据表格（带合计行） -->
          <el-table id="table" :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }" height="500"
                    v-loading="loading" show-summary :summary-method="getSummaries">
            <el-table-column type="index" label="序号" width="60" align="center"  />
            <el-table-column label="客户名称" align="left" prop="compName" min-width="160" show-overflow-tooltip />
            <el-table-column label="使用单位" align="left" prop="usingUnit" min-width="160" show-overflow-tooltip />
            <el-table-column label="应收金额" align="left" prop="totalTestAmount" min-width="120" show-overflow-tooltip />
            <el-table-column label="已收金额" align="left" prop="actualReceiptAmount" min-width="120" show-overflow-tooltip />
            <el-table-column label="调差金额" align="left" prop="discountAmount" min-width="120" show-overflow-tooltip />
            <el-table-column label="未收金额" align="left" prop="unpaidAmount" min-width="120" show-overflow-tooltip />
          </el-table>

          <!-- 分页组件 -->
          <el-pagination style="margin-top: 10px; text-align: right;" @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="queryParams.currPage"
                         :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryReceivableSheet, exportReceivableSheet } from '@/api/contract/contract'
import PermissionMethodToolbar from '@/components/button/PermissionMethodToolbar.vue'

export default {
  name: 'CustomerStatistics',
  props: {
    // 页面URL，用于权限按钮组件
    url: {
      type: String,
      default: ''
    }
  },
  components: {
    PermissionMethodToolbar
  },
  data () {
    return {
      showSearch: true,
      loading: false,
      tableData: [],
      queryParams: {
        compNames: '',
        testEmployeeDate: [],
        currPage: 1,
        pageSize: 200
      },
      total: 0
    }
  },
  created () {
    this.getList()
  },
  methods: {
    buildParams () {
      const params = {
        currPage: this.queryParams.currPage,
        pageSize: this.queryParams.pageSize
      }

      if (this.queryParams.compNames) {
        params.compNames = this.queryParams.compNames
      }

      if (Array.isArray(this.queryParams.testEmployeeDate) && this.queryParams.testEmployeeDate.length === 2) {
        params.testEmployeeDate = this.queryParams.testEmployeeDate
      }

      return params
    },

    normalizeList (res) {
      // 兼容后端返回：{ retCode:'ok', additionalData: { list/records } } 或者 additionalData 直接是数组
      if (res && res.retCode === 'ok') {
        const ad = res.additionalData
        if (Array.isArray(ad)) return ad
        if (ad && Array.isArray(ad.records)) return ad.records
        if (ad && Array.isArray(ad.list)) return ad.list
        return []
      }

      // 兜底：直接返回数组
      if (Array.isArray(res)) return res
      if (res && Array.isArray(res.additionalData)) return res.additionalData
      return []
    },

    // 查询
    handleSearch () {
      // 查询从第一页开始
      this.queryParams.currPage = 1
      this.getList()
    },

    // 重置
    handleReset () {
      this.queryParams.compNames = ''
      this.queryParams.testEmployeeDate = []
      this.queryParams.currPage = 1
      this.getList()
    },

    // 修改每页条数
    handleSizeChange (size) {
      this.queryParams.pageSize = size
      this.queryParams.currPage = 1
      this.getList()
    },

    // 分页切换页码
    handlePageChange (page) {
      this.queryParams.currPage = page
      this.getList()
    },

    // 列表查询
    getList () {
      this.loading = true
      const params = this.buildParams()

      queryReceivableSheet(params).then(res => {
        // 处理分页信息
        if (res && res.retCode === 'ok' && res.additionalData) {
          const ad = res.additionalData
          this.total = ad.total || 0
          if (ad.current !== undefined) {
            this.queryParams.currPage = ad.current
          }
          if (ad.size !== undefined) {
            this.queryParams.pageSize = ad.size
          }
        }

        const list = this.normalizeList(res) || []
        this.tableData = list
        this.loading = false
      }).catch(error => {
        console.error('查询失败:', error)
        this.$message.error('查询失败：' + (error.message || '未知错误'))
        this.tableData = []
        this.loading = false
      })
    },

    // 导出
    exportToExcel () {
      this.$message.success('正在导出客户应收款统计数据...')
      const params = this.buildParams()

      exportReceivableSheet(params).then(response => {
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.download = '客户应收款统计.xlsx'

        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.$message.success('导出成功')
      }).catch(error => {
        console.error('导出失败:', error)
        this.$message.error('导出失败：' + (error.message || '未知错误'))
      })
    },

    toNumber (val) {
      if (val === null || val === undefined || val === '') return 0
      const n = Number(val)
      return Number.isFinite(n) ? n : 0
    },

    formatSum (sum) {
      // 金额类统一保留2位
      return sum.toFixed(2)
    },

    // el-table 合计行
    getSummaries ({ columns, data }) {
      const sums = []
      const noSumProps = ['compName']
      const sumProps = ['finalPrice', 'actualReceiptAmount', 'discountAmount', 'unpaidAmount']

      columns.forEach((column, index) => {
        const prop = column.property

        // 无prop的列（如果未来加了序号列等）
        if (!prop) {
          sums[index] = ''
          return
        }

        if (noSumProps.includes(prop)) {
          sums[index] = '合计'
          return
        }

        if (!sumProps.includes(prop)) {
          sums[index] = ''
          return
        }

        const total = (data || []).reduce((acc, row) => acc + this.toNumber(row[prop]), 0)
        sums[index] = this.formatSum(total)
      })

      return sums
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}
</style>

